<template>
  <v-toolbar
      app
      fixed
      :clipped-left="!mobileView"
    >
      <v-toolbar-side-icon v-if="mobileView" @click="$emit('openNavigation')"/>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn flat v-if="!mobileView">
        <v-icon left>account_circle</v-icon>
        {{ userName }}
      </v-btn>
      <v-btn icon v-else>
        <v-icon>account_circle</v-icon>
      </v-btn>
    </v-toolbar>
</template>

<script>
import { user } from '@/services/'

/**
 * @group AppNavigation
 * Toolbar geral do App, controla a exibição
 * do NavigationDrawer e título da navegação atual.
 */
export default {
  name: 'Toolbar',

  props: {
    // Controle de vizualização do dispositivo
    mobileView: {
      type: Boolean,
      required: true
    },

    // Titulo da toolbar
    title: {
      type: String,
      required: false
    }
  },

  computed: {
    userName () {
      return user.getFirstname()
    }
  }
}
</script>
